import create from "zustand";

// ----------------------------------------------------------------------

const initialToolState = {
  toolHeight: null, // 50,
  toolShape: [], // [0, 0],[0, 1],[1, 0],[1, 1], // Default shape is a square 50x50, than means that it occupies 4 cells in total
  toolName: "", // '50x50x50',
  isRubber: false,
  isSlab: false,
  isProjection: false,
};

const useTool = create((set, get) => ({
  ...initialToolState,
  onChangeTool: (height, shape, name) => 
    set((state) => ({ toolHeight: height, toolShape: shape, toolName: name })),
  setIsRubber: (isRubber) =>
    set((state) => ({ isRubber, isSlab: false, isProjection: false })),
  setIsSlab: (isSlab) =>
    set((state) => ({ isSlab, isRubber: false, isProjection: false })),
  setIsProjection: (isProjection) => {
    if ( get().isProjection ) { // Remove projection tool from selection when already selected
      set((state) => ({ toolHeight: null, toolShape: [], toolName: '', isProjection: false, isSlab: false, isRubber: false }));
    } else {
      set((state) => ({ toolName: 'projection', isProjection, isSlab: false, isRubber: false }));
    }
  },
  resetTool: () => {
    set((state) => initialToolState);
  }
}));

// ----------------------------------------------------------------------

export { useTool };
